import React, {useEffect, useState, useRef} from 'react';
import PropTypes from 'prop-types';
import {useLocation} from 'react-router-dom';
import {getPageData} from '../../lib/tracking';

function AdSlot(props) {
  const { containerId } = props;
  const [adVisible, setAdVisible] = useState(false);
  const retries = useRef(0);
  const location = useLocation();

  const addPageTargeting = () => {
    if (props.pageTargeting) {
      Object.keys(props.pageTargeting).forEach(key => {
        !!props.pageTargeting[key] && window.fusetag.setTargeting(key, props.pageTargeting[key]);
      });
    }
  };

  const loadAd = () => {
    if (window && window.fusetag) {
      addPageTargeting();
      let isVisible = true;
      if (props.hasOwnProperty('visible')) isVisible = props.visible;
      setAdVisible(isVisible);
      if (isVisible) setTimeout(() => {window.fusetag.registerZone(props.adId)}, 500);
    }
    else if (retries.current < 5) {
      retries.current = retries.current + 1;
      setTimeout(() => loadAd(), 500);
    }
  };

  useEffect(() => {
    // mount
    loadAd();
  }, []);

  useEffect(() => {
    // visibility change
    if (props?.visible && props.visible !== adVisible) loadAd();
  }, [props.visible]);

  useEffect(() => {
    if (getPageData().type === 'property search' || getPageData().type === 'suburb profile') {
      loadAd();
    }
  }, [props.pageTargeting?.suburb, props.pageTargeting?.state, props.pageTargeting?.postcode, props.pageTargeting?.property_status, location.search]);

  return (
    adVisible ? <div id={containerId ? containerId : props.adId} style={props.customStyle} data-fuse={props.adId} /> : null
  );
}

AdSlot.propTypes = {
  adId: PropTypes.string.isRequired,
  containerId: PropTypes.string,
  visible: PropTypes.bool,
  pageTargeting: PropTypes.object,
  customStyle: PropTypes.object,
};

export default AdSlot;
